import { FieldHasValue, ValidateNumberField } from 'helpers/Validation';

export const FoundResultAsFoundResultFormula = (formData) => {
    if (
        FieldHasValue(formData.F650asFoundTripPoint)
        && FieldHasValue(formData.F1055AftObservedTripSetpoint)
        && FieldHasValue(formData.F182AftHmireading)
        && FieldHasValue(formData.F101AftTolerance)) {
        if (ValidateNumberField(formData.F183AftDeviation)
            <= ValidateNumberField(formData.F101AftTolerance) && (formData.F182AftHmireading === 'Equipment Tripped')) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
